import React, { ComponentPropsWithRef, forwardRef } from 'react'
import styled from 'styled-components'
import cn from 'classnames'

import InputWrapper from './InputWrapper'

const SInput = styled.input`
    background-color: unset;
    border: unset;
    padding: 10px 15px;
    font-size: 16px;
    font-weight: var(--font-weight-light);
    width: 100%;
    position: relative;

    &.password {
        padding-right: 40px;
    }

    &:not(:placeholder-shown),
    &:focus {
        & ~ label {
            font-size: 12px;
            top: -10px;
            background-color: white;
            border-radius: 2px;
        }
    }

    &:disabled {
        border-color: ${({ theme }) => theme.brandColors.CA_Light_Gray};
        color: ${({ theme }) => theme.brandColors.CA_Mid_Gray};

        & ~ label {
            color: ${({ theme }) => theme.brandColors.CA_Light_Gray};
        }
    }

    &.has-error {
        border-width: 1px;
        border-color: ${({ theme }) => theme.font.errorColor};
    }

    &.noBorder-input {
        border: 1px solid ${({ theme }) => theme.brandColors.CA_Light_Gray};
        border-width: 0 0px 1px 0px;
        background-color: white;
        font-weight: var(--font-weight-normal);
        & ~ label {
            color: ${({ theme }) => theme.brandColors.CA_Black};
        }
    }

    &.default-form-control {
        border-radius: 4px;
    }

    &::-ms-reveal {
        display: none;
    }
`

interface IInputProps extends ComponentPropsWithRef<'input'> {
    id: string
    labelText?: string
    error?: string
    subtitle?: string
    unit?: string
    wrapperClassName?: string
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
}

const Input = forwardRef<HTMLInputElement, IInputProps>((props: IInputProps, ref) => {
    return (
        <InputWrapper
            subtitle={props.subtitle}
            error={props.error}
            id={props.id}
            type={props.type}
            {...(props.disabled && { disabled: props.disabled })}
            {...(props.wrapperClassName && { className: props.wrapperClassName })}
            {...(props.labelText && { labelText: `${props.labelText}${props.required ? ' *' : ''}` })}
        >
            <SInput
                ref={ref}
                placeholder=" "
                className={cn({
                    'has-error': props.error,
                })}
                data-testid={`${props.id}-datepicker`}
                required={props.required}
                type="date"
                {...(props.required && { 'aria-required': true })}
                {...props}
            />
        </InputWrapper>
    )
})

export default Input
